export enum PicoColorEnum {
    P = '81, 87, 166',
    I = '0, 151, 198',
    C = '237, 139, 0',
    O = '132, 189, 0',
    None = '146, 172, 187',
}
